export const VERTEX = /* glsl */ `
  uniform float uTime;
  uniform float uIntensity;
  uniform float uSpeed;
  uniform float uStiffness;
  varying vec2 vUv;
  void main() {
    vUv = uv;
    float swayY = pow(max(position.y, 0.0), uStiffness);
    float sway = sin(uTime * uSpeed + position.y * 2.0) * uIntensity * swayY;
    vec3 displaced = position + vec3(sway, 0.0, 0.0);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(displaced, 1.0);
  }
`;
export const FRAGMENT = /* glsl */ `
  uniform vec3 uBaseColor;
  varying vec2 vUv;
  void main() {
    gl_FragColor = vec4(uBaseColor, 1.0);
  }
`;
